import { render } from "./limit-login-attempts.vue?vue&type=template&id=6ec251e1"
import script from "./limit-login-attempts.vue?vue&type=script&lang=js"
export * from "./limit-login-attempts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__